import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../base.component';
import { MobileIFrameExportPdfAlertModalData } from './mobile.iframe.export.pdf.alert.modal.provider';

@Component({
    templateUrl: './mobile.iframe.export.pdf.alert.modal.component.html',
    styleUrls: ['./mobile.iframe.export.pdf.alert.modal.component.scss']
})
export class MobileIFrameExportPdfAlertModal extends BaseComponent {
    public data: MobileIFrameExportPdfAlertModalData;

    constructor(private modalRef: MatDialogRef<MobileIFrameExportPdfAlertModal>,
                data: MobileIFrameExportPdfAlertModalData) {
        super();
        this.data = Object.assign({}, data);
    }

    public openUrl($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        window.open(this.data.url, '_blank');
        setTimeout(() => {
            this.close();
        });
    }

    public close(): void {
        this.modalRef.close();
    }
}




// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.ts